<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">网站建设</div>
        <div class="type">
          提升品牌形象、扩大市场影响力，并为客户提供便捷的服务和沟通渠道
        </div>
      </div>
      <div id="special">
        <div class="specials swiper-wrapper">
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'web_img1.png'" alt="" />
            </div>
            <div class="title">解决经营难题</div>
            <div class="desc" style="width: 75%">
              中小企业可以解决官网展示、品牌营销、产品推广等经营
            </div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'web_img2.png'" alt="" />
            </div>
            <div class="title">品牌传播与获客转化</div>
            <div class="desc" style="width: 71%">
              提升互联网品牌传播效果，并帮助企业实现客户的转化
            </div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'web_img3.png'" alt="" />
            </div>
            <div class="title">管理提效</div>
            <div class="desc">
              能够帮助企业提升管理效率<br />
              优化运营
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <button class="get" @click="$emit('openDialog')">立即获取专属流量</button>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
        <div class="type">
          帮助企业宣传形象、展示风采、推出产品，更轻松快速地开展互联网营销
        </div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == 0 }"
            @mouseenter="changeType(0)"
          >
            多终端网站
          </div>
          <div
            :class="{ type: true, active: activeType == 1 }"
            @mouseenter="changeType(1)"
          >
            酷炫效果
          </div>
          <div
            :class="{ type: true, active: activeType == 2 }"
            @mouseenter="changeType(2)"
          >
            自适应终端
          </div>
          <div
            :class="{ type: true, active: activeType == 3 }"
            @mouseenter="changeType(3)"
          >
            SEO设置
          </div>
          <div
            :class="{ type: true, active: activeType == 4 }"
            @mouseenter="changeType(4)"
          >
            数据分析
          </div>
        </div>
        <div class="desc">
          <div class="desc_content" v-show="activeType == 0">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/web_img4.png"
                alt=""
                class="post"
              />
              <div class="title">
                拥有电脑网站+手机网站，掌握全渠道流量，实现全网营销
              </div>
            </div>
          </div>
          <div class="desc_content" v-show="activeType == 1">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/web_img5.png"
                alt=""
                class="post"
              />
              <div class="title">
                组织机构官网、企业官网、服务类网站<br />
                产品展示类网站、个性网站按需设计
              </div>
            </div>
          </div>
          <div class="desc_content" v-show="activeType == 2">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/web_img6.png"
                alt=""
                class="post"
              />
              <div class="title">
                复制自适应模板后，同时拥有电脑网站+手机网站<br />
                实现多终端数据一体化
              </div>
            </div>
          </div>
          <div class="desc_content" v-show="activeType == 3">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/web_img7.png"
                alt=""
                class="post"
              />
              <div class="title">丰富强大SEO功能，助力收录排名提升</div>
            </div>
          </div>
          <div class="desc_content" v-show="activeType == 4">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/web_img8.png"
                alt=""
                class="post"
              />
              <div class="title">
                网站数据分析涵盖PV、UV、IP、访问深度、停留时长、着陆页<br />
                及渠道来源、注册情况和页面跳转转化
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      URL,
      activeType: 0,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  mounted() {
    if (this.isMobile) {
      this.initSpecial();
    }
  },
  methods: {
    initSpecial() {
      new window.Swiper("#special", {
        // loop: true,
        centeredSlides: true,
        slidesPerView: 1.5,
        pagination: {
          el: "#special .swiper-pagination",
        },
      });
    },
    changeType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 1200px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.specials {
  width: 1200px;
  margin: 30px auto 0;
  display: flex;
  justify-content: space-between;

  .special {
    width: 32%;
    text-align: center;

    .post {
      width: 100%;
      height: 314px;
      overflow: hidden;

      &:hover {
        img {
          transform: scale(1.1);
        }
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        transition: 0.5s;
      }
    }
    .title {
      font-size: 20px;
      margin-top: 15px;
    }
    .desc {
      width: 70%;
      margin: 15px auto 0;
      color: #6e7685;
      line-height: 26px;
    }
  }
}
.get {
  width: 300px;
  height: 50px;
  margin: 70px auto;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  border-radius: 10px;
  background-color: $theme;
  color: #fff;
  display: block;
}

.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 180px;

  .content {
    width: 1200px;
    margin: 90px auto 0;
    display: flex;

    .types {
      .type {
        width: 250px;
        height: 70px;
        border: 1px solid #eaecee;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          &::after {
            display: block;
          }
        }

        &::after {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent transparent #5f84de;
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
        & + .type {
          margin-top: 30px;
        }
      }
      .active {
        color: $theme;
        background-color: #eaecee;
        box-shadow: 0 16px 16px rgba($color: $theme, $alpha: 0.11);

        &::after {
          display: block;
        }
      }
    }

    .desc {
      flex-grow: 1;
      margin-left: 80px;

      .desc_content {
        display: flex;
        animation: fadeIn 0.5s linear;

        .item {
          width: fit-content;
          text-align: center;
          position: relative;

          & + .item {
            margin-left: 50px;
          }
          .post {
            max-width: 100%;
          }
          .icons {
            position: absolute;
            right: -153px;
            bottom: -153px;
          }
          .icons2 {
            right: 80px;
            bottom: 55px;
          }
          .icon3 {
            right: -296px;
            bottom: 42px;
          }
          .icon {
            width: 100px;
          }
          .title {
            font-size: 20px;
            margin-top: 40px;
          }
          .sub {
            color: #6e7685;
            line-height: 26px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: 1px;
  }
  #special {
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;

    :deep(.swiper-slide) {
      transform: scale(0.9);
      z-index: 10;
    }
    :deep(.swiper-slide-active) {
      transform: scale(1);
      z-index: 10;
    }
  }
  .specials {
    width: 100%;

    .special {
      width: 100%;
      margin-bottom: 10px;

      .post {
        height: 204px;
      }
      .title {
        font-size: 18px;
        margin-top: 10px;
      }
      .desc {
        width: 80%;
        font-size: 14px;
        margin-top: 0;
        line-height: 1.5;
      }
    }
  }
  .get {
    width: 60%;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 40px;
      flex-direction: column;

      .types {
        display: flex;

        .type {
          flex: 1;
          width: unset;
          height: 50px;
          line-height: 1.2;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;

          & + .type {
            margin-top: 0;
          }
        }
        .active::after {
          top: unset;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%) rotate(90deg);
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 60px;

        .desc_content {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          max-width: 100% !important;
          flex-direction: row !important;

          .item {
            & + .item {
              margin-top: 0 !important;
              margin-left: 8px !important;
            }
            .icons2 {
              right: 10px;
              bottom: 30px;

              .icon {
                width: 70px;
              }
            }
            .title {
              font-size: 14px;
              margin-top: 10px;
            }
            .sub {
              width: auto;
              margin-top: 5px;
              line-height: 1.2;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    width: 1000px;

    .types .type {
      width: 200px;
      font-size: 20px;
    }
    .desc .desc_content .item {
      .title {
        font-size: 20px;
      }
      .sub {
        font-size: 14px;
      }
    }
  }
}
</style>
